/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Rajat's Portfolio",
  description:
    "A passionate developer who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Rajat Sahu Portfolio",
    type: "website",
    url: "http://sahurjt.com/",
  },
};

//Home Page
const greeting = {
  title: "Rajat Sahu",
  logo_name: "RajatSahu",
  nickname: "sahurjt",
  subTitle:
    "A passionate developer who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  resumeLink:
    "https://drive.google.com/file/d/1WHlaOs-TexHMJ97rW1y8iTF0Z02K4e0D/view?usp=share_link",
  portfolio_repository: "https://github.com/rjtsahu",
  githubProfile: "https://github.com/rjtsahu",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  {
    name: "Github",
    link: "https://github.com/rjtsahu",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/sahurjt/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:sahurjt@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/Rajat20331863",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/sahurjt/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building scalable microservice and monolithic backend with Java and Python",
        "⚡ Developing native android mobile applications ",
        "⚡ Building responsive website front end using React-Redux",
      ],
      softwareSkills: [
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: ".Net",
          fontAwesomeClassname: "simple-icons:dot-net",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Android",
          fontAwesomeClassname: "simple-icons:android",
          style: {
            color: "#663399",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
        "⚡ Experience with creating multi staged data pipelines using airflow",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "Elastic Search",
          fontAwesomeClassname: "simple-icons:elastic",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Leetcode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://leetcode.com/Rjtsahu/",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@sahurjt",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Government Engineering College,Ujjain",
      subtitle: "B.Tech. in Computer Engineering",
      logo_path: "uecu.png",
      alt_name: "UEC",
      duration: "2013 - 2017",
      descriptions: [
        "⚡ I have studied core software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
        "⚡ Apart from this, I have self learned on multiple FullStack technologies and databases.",
        "⚡ Independently developed minor and major projects and some of them were open-sourced.",
      ],
      website_link: "http://www.uecu.ac.in/",
    },
  ],
};
const certifications = {
  certifications: [
    {
      title: "Microservice with gRPC",
      subtitle: "- microservices",
      logo_path: "linkedin.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/56291e4d01674238ee36d0fa8ad989f3be2690b2504de19d6633cf513158390d?trk=share_certificate",
      alt_name: "Linkedin Learning",
      color_code: "#323754",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: void 0,
  description:
    "I have worked in startups with fast pace agile environment, I have worked as both backend and frontend development and got opportunities to work on Healthcare, Fintech and EdTech domains.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Software Engineer II",
          company: "Gojek",
          company_url: "https://www.gojek.io/",
          logo_path: "gojek-logo.png",
          duration: "Nov 2021 - PRESENT",
          location: "Bangalore, KA",
          description:
            "I am working as fullstack engineer in Gofin GoPayLater product, responsible to create scalable api and maintain and support existing services.",
          color: "#26af06",
        },
        {
          title: "Software Developer ( MTS , SDE-2 , SDE-3 )",
          company: "Nineleaps Technology",
          company_url: "https://www.nineleaps.com/",
          logo_path: "nl-logo.jpeg",
          duration: "Sep 2017 - Oct 2021",
          location: "Bangalore, KA",
          description:
            "In Nineleaps I started my career as MTS (Software Engineer) and got to work with various clients and technologies.I have been promoted to SDE-II and then SDE-III in these 4 years tenure.",
          color: "#0bb7d5",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "I try to experiment with new technologies and ideas hence developed few opensource projects.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "sahurjt.png",
    description:
      "I am available on almost every social media. Lets connect or just drop a Hi 👋🏼.",
  },
  blogSection: {
    title: "Blogs (WIP)",
    subtitle: "Still procrastinating on this 😅",
    link: "",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Bangalore, KA, India",
    avatar_image_path: "address_image.svg",
    location_map_link:
      "https://www.google.com/maps/place/Bengaluru,+Karnataka/@12.9542946,77.4908552,11z/data=!3m1!4b1!4m5!3m4!1s0x3bae1670c9b44e6d:0xf8dfc3e8517e4fe0!8m2!3d12.9715987!4d77.5945627",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91-8269328329",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  contactPageData,
};
